export const referenceError = {
  active: false,
  keyError: 422
};
